// removed by extract-text-webpack-plugin
module.exports = {"Topbread":"index__Topbread__1PqcG","createBtn":"index__createBtn__1QXp4","pageTop":"index__pageTop__8QVe_","pageTitle":"index__pageTitle__3Z9qJ","cardList":"index__cardList__2CGZd","card":"index__card__nAjm7","item":"index__item__1i6qF","extraImg":"index__extraImg__1JOzR","_list_link_to":"index___list_link_to__iWe7R","newButton":"index__newButton__N2L6I","cardAvatar":"index__cardAvatar__3zqsn","cardDescription":"index__cardDescription__1ij5R","pageHeaderContent":"index__pageHeaderContent__Vus_c","contentLink":"index__contentLink__2fsxO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Products/Form/index.less
// module id = 1332
// module chunks = 0